<template>
  <div class="fileUploader">
    <div class="title">{{ $t("form.add_photo") }}</div>
    <div class="img-container" >
      <img v-if="imageData" :src="imageData" alt="">
    </div>
    <input type="file" class="txtFile" :id="'txtFile-' + uniqueKey" @change="loadImage($event)">
    <label :for="'txtFile-' + uniqueKey" v-if="!imageData">+</label>
    <div class="remove" v-if="imageData" @click="remove">+</div>
  </div>
</template>

<script>

  import resize from "image-blob-reduce";

  export default {

    name: "fileUploader",

    props: {
      uniqueKey: String
    },

    data() {
      return {
        imageData: null
      };
    },

    methods: {
      loadImage(e) {
        let input = e.target;
        if (input.files && input.files.length == 1) {
          let reader = new FileReader();
          let split = input.files[0].name.split(".");
          let extension = split[split.length - 1];
          showSpinner();
          reader.onload = async () => {
            this.imageData = await this.compressImage(input.files[0]);
            hideSpinner();
            if (this.imageData) {
              this.$emit("upload", {
                name: input.files[0].name,
                type: input.files[0].type,
                extension: extension,
                data: this.imageData
              });
            }
          };
          reader.readAsDataURL(input.files[0]);
        }
      },
      remove() {
        this.imageData = null;
        this.$emit("upload", null);
        if (document.getElementById('txtFile-' + this.uniqueKey)) {
          document.getElementById('txtFile-' + this.uniqueKey).value = "";
        }
      },
      async compressImage(original) {
        return new Promise(async (resolve, reject) => {
          if (!["image/png", "image/jpeg", "image/gif"].includes(original.type)) {
            showAffirmation(this.$t("error"), this.$t("errors.file_type_image"));
            resolve();
            return;
          }

          let blob   = new Blob([ original ], { type: 'image/jpeg' });
          let resizer = resize();
          let result;

          try {
            result = await resizer.toBlob(blob, { max: 1000 });
          } catch (e) {
            console.log("error resize", e);
            showAffirmation(this.$t("error"), this.$t("errors.file_size"));
            resolve();
          }

          let reader = new FileReader();
          reader.onload = function () {
            resolve(reader.result);
          };
          reader.readAsDataURL(result);
        });
      }
    }

  }

</script>

<style lang="scss" scoped>

  .fileUploader {
    background-color: white;
    border: 1px solid #d5dde0;
    padding: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .title {
    font-size: 10px;
    color: #d5dde0;
    text-transform: uppercase;
    margin-bottom: 6px;
  }

  .txtFile {
    display: none;
    & + label, & + .remove {
      width: 40px;
      height: 40px;
      background-color: #bfc5c8;
      position: absolute;
      top: 10px;
      right: 10px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white !important;
      cursor: pointer;
      font-size: 40px;
      line-height: 1;
      padding-bottom: 4px;
    }
  }

  .img-container {
    align-self: center;
    height: 120px;
    img {
      object-fit: contain;
      height: 100%;
      max-width: 100%;
      align-self: center;
    }
  }

  .remove {
    transform: rotateZ(45deg);
  }

</style>